import React from 'react';
import { Boxes } from 'lucide-react';
import { BulkOperationsPanel } from '@/components/bulk/BulkOperationsPanel';

export default function BulkPage() {
  return (
    <div className="space-y-8">
      <section>
        <h2 className="flex items-center gap-2 text-2xl font-semibold text-neutral-900">
          <Boxes className="h-6 w-6 text-neutral-500" aria-hidden />
          Bulk & Automation
        </h2>
        <p className="mt-1 text-sm text-neutral-500">
          Import CSV data, perform mass updates, and streamline operational
          tasks for the cyber range quiz platform.
        </p>
      </section>

      <BulkOperationsPanel />
    </div>
  );
}

